module.exports = "<div class=\"thinker\">\r\n    <div class=\"bspinner\">\r\n        <div class=\"bounce1\"></div>\r\n        <div class=\"bounce2\"></div>\r\n        <div class=\"bounce3\"></div>\r\n    </div>\r\n</div>\r\n<div class=\"alert-content\">\r\n    <table>\r\n        <tr>\r\n            <td class=\"report-enabled\"><b>Enabled</b></td>\r\n            <td class=\"report-name\"><b>Name</b></td>\r\n        </tr>\r\n    </table>\r\n    <div id=\"alerts-report-list-region\">\r\n    </div>\r\n</div>\r\n<div class=\"alerts-message\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/alerts-reports.html
// module id = 370
// module chunks = 1